// 邮件管理
import http from "@/jslibs/axios/http";

// 邮件详情
export const detail = (id) => http.get("/cms/emailSendRecord/details/" + id);

// 邮件分页列表
export const page = (data) => http.get("/cms/emailSendRecord/page", data);

// 邮件导出
export const excel = (data) => http.post("/cms/emailSendRecord/excel", data, { responseType: "blob" });
